var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightLongArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 36,
    viewBox: "0 0 101 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.707 18.7071C101.098 18.3166 101.098 17.6834 100.707 17.2929L94.3431 10.9289C93.9526 10.5384 93.3195 10.5384 92.9289 10.9289C92.5384 11.3195 92.5384 11.9526 92.9289 12.3431L98.5858 18L92.9289 23.6569C92.5384 24.0474 92.5384 24.6805 92.9289 25.0711C93.3195 25.4616 93.9526 25.4616 94.3431 25.0711L100.707 18.7071ZM0 19H100V17H0V19Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLongArrow);
export default __webpack_public_path__ + "static/media/right-long-arrow.dd3e16261e7c1cef5d2e6d8d58aa4a15.svg";
export { ForwardRef as ReactComponent };